import { useQuery } from "@tanstack/react-query"
import {
  queryEmployeeOutreach,
  getOutreachCompanies,
} from "@/api/employeeOutreach"
import type { EmployeeOutreachParams } from "@/api/employeeOutreach"

export const useEmployeeOutreach = (
  params: EmployeeOutreachParams,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ["employeeOutreach", params],
    queryFn: () => queryEmployeeOutreach(params),
    staleTime: 1000 * 60 * 5,
    enabled,
  })
}

export const useOutreachCompanies = () => {
  return useQuery({
    queryKey: ["outreachCompanies"],
    queryFn: () => getOutreachCompanies(),
    staleTime: 1000 * 60 * 10,
  })
}
